// extracted by mini-css-extract-plugin
module.exports = {"viewBody":"viewBody--1O-13","descWrap":"descWrap--aVRqz","title":"title--4AYs0","icontent":"icontent--35yQb"};